import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  EventAvailableRequest,
  EventAvailableResponse,
  EventBraceletColorsResponse,
  EventCancelRequest,
  EventCatalogRequest,
  EventConfigResponse,
  EventCreateRequest,
  EventCreateResponse,
  EventEmptyResponse,
  EventFinalizeRequest,
  EventFindAllRequest,
  EventFindAllResponse,
  EventFindGuestRequest,
  EventFindGuestResponse,
  EventFindGuestsRequest,
  EventFindGuestsResponse,
  EventFindRequest,
  EventFindResponse,
  EventGuestConfigRequest,
  EventMunicipalitiesRequest,
  EventMunicipalitiesResponse,
  EventParishesRequest,
  EventParishesResponse,
  EventRemoveGuestRequest,
  EventRemoveRequest,
  EventRingConfigRequest,
  EventRingsResponse,
  EventStaffAvailableRequest,
  EventStaffAvailableResponse,
  EventStaffConfigRequest,
  EventStatesResponse,
  EventStatusesResponse,
  EventSummaryResponse,
  EventTypesResponse,
  EventUpdateGuestRingRequest,
  EventUpdateRequest,
  EventVenueConfigRequest,
} from '../dto';

export abstract class EventRepository {
  abstract findAllPath(): string;
  abstract findAll(request: EventFindAllRequest): Observable<HttpResponse<EventFindAllResponse>>;
  abstract findById(request: EventFindRequest): Observable<HttpResponse<EventFindResponse>>;
  abstract getEventSummaryById(
    request: EventFindRequest,
  ): Observable<HttpResponse<EventSummaryResponse>>;
  abstract create(request: EventCreateRequest): Observable<HttpResponse<EventCreateResponse>>;
  abstract update(request: EventUpdateRequest): Observable<HttpResponse<EventEmptyResponse>>;
  abstract remove(request: EventRemoveRequest): Observable<HttpResponse<EventEmptyResponse>>;
  abstract finalize(request: EventFinalizeRequest): Observable<HttpResponse<EventEmptyResponse>>;
  abstract cancel(request: EventCancelRequest): Observable<HttpResponse<EventEmptyResponse>>;
  abstract saveRingConfig(
    request: EventRingConfigRequest,
  ): Observable<HttpResponse<EventConfigResponse>>;
  abstract saveVenueConfig(
    request: EventVenueConfigRequest,
  ): Observable<HttpResponse<EventConfigResponse>>;
  abstract saveGuestConfig(
    request: EventGuestConfigRequest,
  ): Observable<HttpResponse<EventConfigResponse>>;
  abstract updateGuestRing(
    request: EventUpdateGuestRingRequest,
  ): Observable<HttpResponse<EventEmptyResponse>>;
  abstract removeGuest(
    request: EventRemoveGuestRequest,
  ): Observable<HttpResponse<EventEmptyResponse>>;
  abstract findGuestsPath(id: number): string;
  abstract findGuests(
    request: EventFindGuestsRequest,
  ): Observable<HttpResponse<EventFindGuestsResponse>>;
  abstract findGuestById(
    request: EventFindGuestRequest,
  ): Observable<HttpResponse<EventFindGuestResponse>>;
  abstract getStaffAvailable(
    request: EventStaffAvailableRequest,
  ): Observable<HttpResponse<EventStaffAvailableResponse>>;
  abstract getEventsAvailable(
    request: EventAvailableRequest,
  ): Observable<HttpResponse<EventAvailableResponse>>;
  abstract saveStaffConfig(
    request: EventStaffConfigRequest,
  ): Observable<HttpResponse<EventConfigResponse>>;
  abstract getStates(request: EventCatalogRequest): Observable<HttpResponse<EventStatesResponse>>;
  abstract getMunicipalities(
    request: EventMunicipalitiesRequest,
  ): Observable<HttpResponse<EventMunicipalitiesResponse>>;
  abstract getParishes(
    request: EventParishesRequest,
  ): Observable<HttpResponse<EventParishesResponse>>;
  abstract getEventTypes(request: EventCatalogRequest): Observable<HttpResponse<EventTypesResponse>>;
  abstract getEventStatuses(request: EventCatalogRequest): Observable<HttpResponse<EventStatusesResponse>>;
  abstract getRings(request: EventCatalogRequest): Observable<HttpResponse<EventRingsResponse>>;
  abstract getBraceletColors(request: EventCatalogRequest): Observable<HttpResponse<EventBraceletColorsResponse>>;
}
